import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import './AddAdminPanel.css';

const AddAdminPanel = ({ onClose, quizId, userEmail }) => {
    const [admins, setAdmins] = useState([]);
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const panelRef = useRef(null);

    useEffect(() => {
        if (quizId) {
            fetchAdmins();
        }

        const handleClickOutside = (event) => {
            if (panelRef.current && !panelRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [quizId]);

    const fetchAdmins = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`/api/quizzes/${quizId}/admins`);
            setAdmins(response.data.admins || []);
        } catch (error) {
            console.error('Error');
        } finally {
            setIsLoading(false);
        }
    };

    const handleAddAdmin = async () => {
        try {
            const response = await axios.post('/api/admins', { quizId, email });
            setEmail('');
            fetchAdmins();
            setError('');
        } catch (error) {
            if (error.response && error.response.data) {
                setError(error.response.data.error);
            } else {
                console.error('Error');
            }
        }
    };

    const handleRemoveAdmin = async (email) => {
        try {
            await axios.delete('/api/admins', {
                data: { quizId, email }
            });
            fetchAdmins();
        } catch (error) {
            console.error('Error');
        }
    };

    return (
        <div className="add-admin-panel">
            <div className="add-admin-panel__panel" ref={panelRef}>
                <button className="add-admin-panel__close-button" onClick={onClose}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
                <h2>Ajouter un Administrateur</h2>
                <input
                    type="email"
                    placeholder="Entrez l'email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <button className="add-admin-panel__add-button" onClick={handleAddAdmin}>Ajouter</button>
                {error && <p className="add-admin-panel__error">{error}</p>}
                <div className="add-admin-panel__admin-list">
                    {isLoading ? (
                        <p>Chargement...</p>
                    ) : (
                        admins.map((adminEmail, index) => (
                            <div key={adminEmail} className="add-admin-panel__admin-item">
                                <span>{adminEmail}</span>
                                {adminEmail !== userEmail && index !== 0 && (
                                    <button className="add-admin-panel__remove-button" onClick={() => handleRemoveAdmin(adminEmail)}>Supprimer</button>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default AddAdminPanel;
